module.exports = __webpack_public_path__ + "media/packs/autocatalog/components/mobile/SpecSummary/images/capacity-c38a6436fe3330944d5671c023f76ef8.png";